import React from "react";
import { Button } from "antd-mobile";
import "./RecommendPolicy.scss";

export default function(props) {
  return (
    <div className="recommend-policy">
      <div className="recommend-policy__content">
        <h2 style={{ textAlign: "center" }}>
          人才推荐及奖励政策（H01-H04部分)
        </h2>
        <section>
          <h3>一. H01-H04职位推荐要求：</h3>
          <ol>
            <li>不可推荐未年满18周岁，不符合公司一线员工录用标准的员工。</li>
            <li>不可推荐寒暑假工、短期工。</li>
            {/* <li>不可推荐不认识或不熟悉的人。</li> */}
            {/* <li>不可代替他人进行内部推荐。</li> */}
            <li>推荐人不可与外部第三方单位合作。</li>
            {/* <li>推荐人须如实告知与被推荐人的关系，填写真实完整的信息。</li> */}
            <li>被推荐人需遵照公司面试流程统一面试和录用。</li>
            <li>
              被推荐人的简历准确真实，推荐人不可协助被推荐人做任何隐瞒和伪造。
            </li>
            <li>
              如被推荐人有任何刑事犯罪记录或其他严重影响工作的疾病或传染性疾病，推荐人须如实向公司申明，不可故意隐瞒。
            </li>
          </ol>
        </section>
        <section>
          <h3>二. H01-H04职位推荐流程：</h3>
          <ol>
            <li>
              推荐人将推荐页面分享给被推荐人，被推荐人扫描二维码，注册登录，根据系统提示填写求职信息，预约面试并按预约日期至公司参加面试。
            </li>
            <li>
              部门回避：分配部门时，原则上被推荐人与推荐人不可安排在同一部门。
            </li>
          </ol>
        </section>
        <section>
          <h3>三. H01-H04职位推荐成功奖励办法：</h3>
          <ol>
            <li>
              奖励方式：按被推荐人实际在司工作时长分月返还。具体奖励方案由人力资源部根据市场情况定期更新，请实时关注人力资源部公告。
            </li>
            <li>
              人力资源部负责推荐奖金的核算及发放；每月15日之后统计上月符合发放推荐奖人员名单，核算周期为上月16日至当月15日；推荐奖金随当月工资一起发放。
            </li>
            <li>
              本奖励政策不适用于下情况：
              <ul>
                <li>推荐人或被推荐人离职。</li>
                <li>
                  被推荐人曾在公司（包括菲尼萨上海、无锡及派遣外包人员）任职。
                </li>
                <li>被推荐人与推荐人在同一生产线工作或存在直接上下级关系。</li>
                <li>
                  推荐人为人力资源部员工、生产培训部员工、生产部组长及以上职位人员。
                </li>
              </ul>
            </li>
          </ol>
        </section>
        <section>
          <h3>四. 以下情况，推荐人不适用本奖励政策且取消推荐资格：</h3>
          <ol>
            <li>被推荐人为寒暑假工、短期工，应聘H01-H04职位。</li>
            <li>推荐人与外部第三方单位合作。</li>
            <li>推荐人隐瞒或捏造被推荐人相关信息。</li>
            <li>被推荐人提供虚假信息或资料。 </li>
            <li>
              推荐人隐瞒任何被推荐人刑事犯罪记录或其他严重影响工作的疾病或传染性疾病。
            </li>
          </ol>
        </section>
        <section>
          <h3>
            五.
            其他：如有问题，请直接联系人力资源部相关人员（0510-68007800-7632、7631）
          </h3>
        </section>
      </div>
      <div className="recommend-policy__footer">
        <Button
          type="primary"
          onClick={() => {
            props.history.push("/invite_induction");
          }}
          style={{ marginBottom: 8 }}
        >
          我要推荐
        </Button>
        <Button
          onClick={() => {
            props.history.goBack();
          }}
        >
          返回
        </Button>
      </div>
    </div>
  );
}
